import { SmartTable } from '../../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state, UserLabelsService, Alert) {
		this.$state = $state;
		this.UserLabelsService = UserLabelsService;
        this.Alert = Alert;
    }

    $onInit() {
        
        this.allItems = [...this.regCompanyUsers]
            .filter(({companyUserId}) => !companyUserId);
		this.usersAlreadyInTeam=angular.copy(this.companyUsers);
		this.st = new SmartTable();
		this.usersNotInTeam = this.allItems.filter( el => !this.usersAlreadyInTeam.some(function(item){
  			return item.saaspassId.includes(el.saaspassId);
				}) );
    }

   import() {
		//const selectedItems=this.st.selectedItems.filter((e)=>e.roleType);
		//var selectedIds=selectedItems.map((e) =>e.id);
        this.isSaving = true;
		var companyId=this.companyId;
		var labelId=this.userLabelId;
        this.UserLabelsService
            .addCompanyUsers({companyId,labelId}, this.st.selectedIds).$promise
            .then(() => {
				let tempArray=angular.copy(this.st.selectedItems);
				const newArray = tempArray.map(({isSelected, ...keepArray}) => keepArray);
				Array.prototype.push.apply(this.companyUsers,newArray);
				 this.$state.go('^', {}, {reload: '^.^'});
            	 })
			.then(() =>this.Alert('success', 'company.user-directories.saaspass-users.user-labels.users.import.imported'))
			.catch((error) =>{ 
						this.Alert('danger', error.data.message)})
            .finally(() => this.isSaving = false)
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/import/import-users-to-label.controller.js